import { render, staticRenderFns } from "./HeaderArea.vue?vue&type=template&id=fa91b70a&scoped=true"
import script from "./HeaderArea.vue?vue&type=script&lang=js"
export * from "./HeaderArea.vue?vue&type=script&lang=js"
import style0 from "./HeaderArea.vue?vue&type=style&index=0&id=fa91b70a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa91b70a",
  null
  
)

export default component.exports